import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';
import { CellItem, DayItem, HourItem, RowItem } from '../../../stores/TimetableVersion/PinboardStoreTypes';
import { GridCards } from '../GridCards/GridCards';
import { GridCell } from '../GridCell/GridCell';
import styles from './../TimetableGrid.module.scss';

export const GridDay = observer(
  ({
    daysWidth,
    hours,
    row,
    day,
    dayIndex,
    cellWidth,
  }: {
    daysWidth: string;
    cellWidth: string;
    hours: HourItem[];
    row: RowItem;
    day: DayItem;
    dayIndex: number;
  }) => {
    return (
      <div className={styles['row']} style={{ flex: `1 1 ${daysWidth}` }}>
        {hours.map((hour) => {
          const cell: CellItem = {
            row: { label: row.label, value: row.value, isFunctionClass: row.isFunctionClass },
            day,
            hour,
          };
          if (hour.isPause) {
            return <Fragment key={`${row.value}-${day.value}-${hour.value}-pause`}></Fragment>;
          }
          return (
            <div
              key={`${row.value}-${day.value}-${hour.value}-cell`}
              style={{ position: 'relative', width: 'calc(100% - 2px)', height: '100%' }}
            >
              <GridCell
                key={`${row.value}-${day.value}-${hour.value}`}
                cell={cell}
                dayIndex={dayIndex}
                width={cellWidth}
              />
              <GridCards cell={cell} />
            </div>
          );
        })}
      </div>
    );
  },
);
GridDay.displayName = 'GridDay';
